import React, { useState } from "react";
import Link from "next/link";
import { connect } from "react-redux";
import { toggleLoading } from "../../../state/creators";
import { Props } from "../../../_interfaces/data.reset2Form.interface";
import { UserReset2Model } from "../../../_models/data.userReset2.model";
import { ApiResultModel } from "../../../_models/api.result.model";
import { ValidateReset2 } from "../../../functions/validators";
import { Reset2 } from "../../../functions/http-functions/auth";
import Password from "../inputs/password";
import FormError from "../errors/http";
import { Form } from "../../../styles/forms";
import { ButtonList, StandardLink, SubmitButton } from "../../../styles/type/buttons";
import { StandardButtonAnchor } from "../../../styles/type/buttons";
import { AssistiveText, Cta } from "../../../styles/type/typography";
import { IHttpResponse } from "../../../functions/http-functions/http";
import { useRouter } from "next/router";

const ResetForm: React.FC<Props> = ({ userId, resetCode, toggleLoading }) => {
	const [state, setState] = useState(new UserReset2Model({ userId, resetCode }));
	const [error, setError] = useState(null);
	const [success, setSuccess] = useState(null);

	const router = useRouter();

	const handleChange = ({ target: { name, value } }) => {
		setState((prevState) => ({ ...prevState, [name]: value }));
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		setState((prevState) => ({
			...prevState,
			passwordError: null,
			confirmPasswordError: null,
		}));
		const ValidateStep = ValidateReset2({ ...state });
		if (ValidateStep.valid) {
			reset();
		} else {
			for (let i = 0, item; !!(item = ValidateStep.errors[i++]); ) {
				setState((prevState) => ({
					...prevState,
					[item.name]: item.error,
				}));
			}
		}
	};

	const reset = async () => {
		toggleLoading(true);
		Reset2(new UserReset2Model({ ...state, userId, resetCode }))
			.then((res) => setSuccess(true))
			.catch((err: unknown) => {
				const error = err as IHttpResponse;
				const ErrorResult = new ApiResultModel(error);
				setError(<FormError errors={[ErrorResult.message]} />);
			})
			.then(() => toggleLoading(false));
	};

	return (
		<>
			{success ? (
				<AssistiveText>
					<p>Your password has been reset successfully. You can now login with your updated account details.</p>
					<ButtonList justify="center">
						<StandardLink href="/login" full>
							Login
						</StandardLink>
					</ButtonList>
				</AssistiveText>
			) : (
				<Form>
					<Password name="password" label="New Password" value={state.password} onChange={handleChange} error={state.passwordError} required={true} />
					<Password name="confirmPassword" label="Confirm Password" value={state.confirmPassword} onChange={handleChange} error={state.confirmPasswordError} required={true} />
					{error}
					<ButtonList justify={"space-between"}>
						<Cta center onClick={() => router.push("/login")}>
							Back to Login
						</Cta>
						<div>
							<SubmitButton onClick={handleSubmit} full>
								Reset
							</SubmitButton>
						</div>
					</ButtonList>
				</Form>
			)}
		</>
	);
};

const mapDispatchToProps = {
	toggleLoading,
};

export default connect(null, mapDispatchToProps)(ResetForm);
